import {filter} from 'rxjs/operators';
import {wsMsg$} from '@/ws';
import type {ws} from '@/types';
type TickMsg = ws.TickMsg;

export const tickMsg$ = wsMsg$.pipe(filter((o: TickMsg) => !!o.tick));
